unit View.Usuarios.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls,
  UHelperServer, WEBLib.WebCtrls, UConstantes, Web, System.StrUtils, UUtils,
  UWeb.Enum, UFramePermissoesUsuario, Vcl.Forms, WEBLib.Grids,
  Auth.Service;

type
  TFViewUsuariosEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbperfil: TLabel;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbemail: TLabel;
    edemail: TDBEdit;
    lbstatus: TLabel;
    XDataClientUsuariosGet: TXDataWebClient;
    UsuariosDataset: TXDataWebDataSet;
    UsuariosDatasetid: TIntegerField;
    UsuariosDatasetaliado_id: TIntegerField;
    UsuariosDatasetparceiro_id: TIntegerField;
    UsuariosDatasetperfil: TIntegerField;
    UsuariosDatasetnome: TStringField;
    UsuariosDatasetemail: TStringField;
    UsuariosDatasetstatus: TIntegerField;
    UsuariosDatasetultimo_acesso: TDateTimeField;
    UsuariosDatasetinclusao: TDateTimeField;
    UsuariosDatasetalteracao: TDateTimeField;
    cbbStatus: TComboBox;
    cbbPerfil: TComboBox;
    divAliado: THTMLDiv;
    lbaliado_id: TLabel;
    edtAliadoNome: TEdit;
    btnPesquisarAliado: TButton;
    divParceiro: THTMLDiv;
    lbparceiro_id: TLabel;
    edtParceiroNome: TEdit;
    btnPesquisarParceiro: TButton;
    UsuariosDatasetaliadoNome_Fantasia: TXDataWebDatasetField;
    UsuariosDatasetparceironome: TXDataWebEntityField;
    divCheckBoxServidores: THTMLDiv;
    cbxTodosServidores: TCheckBox;
    UsuariosDatasetperfil_acesso: TStringField;
    btnPermissoesUsuario: TButton;
    frmPermissoesUsuario: TFramePermissoesUsuario;
    UsuariosDatasetsomente_apis: TBooleanField;
    UsuariosDatasettoken_longa_duracao: TStringField;
    pnlDados: TPanel;
    cbxUtilizaSomenteApi: TDBCheckBox;
    lbultimo_acesso: TLabel;
    edultimo_acesso: TDBEdit;
    edinclusao: TDBEdit;
    lbinclusao: TLabel;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    pnlApi: TPanel;
    lblToken: TLabel;
    edtToken: TDBEdit;
    btnCopiarToken: TButton;
    lblExpiracaoToken: TLabel;
    edtExpiracaoToken: TEdit;
    btnAtualizarToken: TButton;
    XDataWebClientToken: TXDataWebClient;
    procedure btCancelClick(Sender: TObject);
    [async]
    procedure btSaveClick(Sender: TObject); async;
    procedure XDataClientUsuariosGetLoad(Response: TXDataClientResponse);
    procedure UsuariosDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
    procedure btnPesquisarAliadoClick(Sender: TObject);
    procedure btnPesquisarParceiroClick(Sender: TObject);
    procedure cbbPerfilChange(Sender: TObject);
    procedure cbxTodosServidoresClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure ednomeClick(Sender: TObject);
    procedure edemailClick(Sender: TObject);
    procedure cbbStatusClick(Sender: TObject);
    procedure cbbPerfilClick(Sender: TObject);
    procedure btnPermissoesUsuarioClick(Sender: TObject);
    procedure cbxUtilizaSomenteApiClick(Sender: TObject);
    procedure XDataWebClientTokenError(Error: TXDataClientError);
    procedure XDataWebClientTokenLoad(Response: TXDataClientResponse);
    procedure btnCopiarTokenClick(Sender: TObject);
    [async]
    procedure btnAtualizarTokenClick(Sender: TObject); async;
  private
    const
      FPrefixoCheckBoxServidores = 'cbx_servidores_';

    var
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
    procedure ConfigurarPerfil;
    procedure SetDadosTela;
    procedure CriarCheckBoxServidores;
    procedure ControlarCheckBoxServidores(pVisible : Boolean);
    procedure SetServidoresAliado;
    procedure SetDadosCds(pNovoRegistro : Boolean = True);
    function GetServidoresSelecionados : string;
    function ValidarPost : TArray<string>;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewUsuariosEdit: TFViewUsuariosEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewUsuariosEdit }

procedure TFViewUsuariosEdit.btnAtualizarTokenClick(Sender: TObject);
var
  lDataToken : string;
  lJson : TJSObject;
begin
  lDataToken := edtExpiracaoToken.Text;

  if not lDataToken.IsEmpty and (StrToDateTime(lDataToken) > Now) then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Não é possível atualizar o token' +
      ' antes da sua expiração');

    Exit;
  end;

  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja' +
    ' atualizar o token?')) then
  begin
    TUtils.ChamarDivLoading;
    lJson := TJSObject.New;
    lJson['codigo_usuario'] := edid.Text;
    XDataWebClientToken.RawInvoke('IService.AtualizarTokenUsuario', [lJson]);
  end;
end;

procedure TFViewUsuariosEdit.btnCopiarTokenClick(Sender: TObject);
begin
  THelperServer.CopiarTextoNotificacao('Token copiado com sucesso!', 'Cópia de token',
    edtToken.Text);
end;

procedure TFViewUsuariosEdit.btnPermissoesUsuarioClick(Sender: TObject);
begin
  frmPermissoesUsuario.FUsuarioId := StrToInt(edid.Text);
  frmPermissoesUsuario.SetTituloModal('Permissões para o usuário ' + ednome.Text);
  frmPermissoesUsuario.ReiniciarCds;
  asm
    $('#line-service-tab').tab('show');
  end;
  TUtils.OpenModal('modal_permissoes');
  frmPermissoesUsuario.CarregarCds(frmPermissoesUsuario.cdsPermissoesService);
end;

procedure TFViewUsuariosEdit.btnPesquisarAliadoClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_usuarios_form_lbaliado');
  THelperServer.ChamarConsulta('Aliados', 'Aliado', edtAliadoNome, True);
end;

procedure TFViewUsuariosEdit.btnPesquisarParceiroClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_usuarios_form_lbparceiro');
  THelperServer.ChamarConsulta('Parceiros', 'Parceiros', edtParceiroNome, True);
end;

procedure TFViewUsuariosEdit.btSaveClick(Sender: TObject);
var
  lMensagem : string;
  lErro : TArray<string>;
begin
  lErro := ValidarPost;
  if lErro[0] <> '' then
  begin
    TUtils.SetErroClass(lErro[1], lErro[0]);

    Exit;
  end;

  if GetServidoresSelecionados = '' then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Nenhum servidor selecionado!');

    Exit;
  end;


  lMensagem := 'Tem certeza que deseja cadastrar este usuário?';

  if not FInserting then
    lMensagem := 'Tem certeza que deseja atualizar os dados deste usuário?';

  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, lMensagem)) then
  begin
    if UsuariosDataset.State in dsEditModes then
    begin
      TUtils.ChamarDivLoading;
      SetDadosCds(FInserting);
      UsuariosDataset.Post;
      UsuariosDataset.ApplyUpdates;
    end
    else
      FShowListProc;
  end;
end;

procedure TFViewUsuariosEdit.cbbPerfilChange(Sender: TObject);
begin
  ConfigurarPerfil;
end;

procedure TFViewUsuariosEdit.cbbPerfilClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_usuarios_form_lbperfil');
end;

procedure TFViewUsuariosEdit.cbbStatusClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_usuarios_form_lbstatus');
end;

procedure TFViewUsuariosEdit.cbxTodosServidoresClick(Sender: TObject);
begin
  ControlarCheckBoxServidores(not cbxTodosServidores.Checked);
end;

procedure TFViewUsuariosEdit.cbxUtilizaSomenteApiClick(Sender: TObject);
begin
  if not TUtils.IsPerfilFacilSistemas(TUtils.FUsuario) then
    Exit;

  edemail.Enabled := not cbxUtilizaSomenteApi.Checked;

  if cbxUtilizaSomenteApi.Checked then
  begin
    UsuariosDataset.FieldByName('email').AsString := EmptyStr;
    cbbStatus.ItemIndex := 1;
  end
  else
    cbbStatus.ItemIndex := 3;
end;

procedure TFViewUsuariosEdit.ConfigurarPerfil;
begin
  if TUtils.IsPerfilAliado(TUtils.FUsuario) then
  begin
    asm
      $('#view_usuarios_form_lbaliado_error_div').addClass('d-none');
    end;

    TUtils.RemoverElementoPorId('view_usuarios_form_lbparceiro_error_div');
  end
  else
  begin
    asm
      $('#view_usuarios_form_lbaliado_error_div').addClass('d-none');
      $('#view_usuarios_form_lbparceiro_error_div').addClass('d-none');
    end;
  end;

  if cbbPerfil.ItemIndex = 2 then
  begin
    asm
      $('#view_usuarios_form_lbparceiro_error_div').removeClass('d-none');
    end;
  end
  else if cbbPerfil.ItemIndex = 3 then
  begin
    asm
      $('#view_usuarios_form_lbaliado_error_div').removeClass('d-none');
    end;
  end;
end;

procedure TFViewUsuariosEdit.ControlarCheckBoxServidores(pVisible: Boolean);
var
  lIdCheckBox : string;
  lIndice : Integer;
  lElement: TJSHTMLInputElement;
begin
  for lIndice := Low(FServidoresDisponiveis) to High(FServidoresDisponiveis) do
  begin
    lIdCheckBox := FPrefixoCheckBoxServidores + IntToStr(lIndice + 1);

    lElement := TJSHTMLInputElement(document.getElementById(lIdCheckBox));

    if Assigned(lElement) then
    begin
      if not pVisible then
        lElement.checked := False;

      lElement.disabled := not pVisible;
    end;
  end;
end;

class function TFViewUsuariosEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewUsuariosEdit.CriarCheckBoxServidores;
var
  lDivCriadaHtml,
  lIdCheckBox,
  lIdLabel : string;
  lIndice : Integer;
begin
  for lIndice := Low(FServidoresDisponiveis) to High(FServidoresDisponiveis) do
  begin
    lIdCheckBox := FPrefixoCheckBoxServidores + IntToStr(lIndice + 1);
    lIdLabel := 'lbl_servidor_' + IntToStr(lIndice + 1);
    lDivCriadaHtml := '<div class="form-check"><input class="form-check-input" '+
    'type="checkbox" value="'+IntToStr(lIndice + 1)+'" id="'+lIdCheckBox+'"/><label class="form-check-label" id="'+
      lIdLabel+'" for="'+lIdCheckBox+'">'+ FServidoresDisponiveis[lIndice]+'</label></div>';

    divCheckBoxServidores.HTML.Add(lDivCriadaHtml);
  end;
end;

procedure TFViewUsuariosEdit.edemailClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_usuarios_form_lbemail');
end;

procedure TFViewUsuariosEdit.ednomeClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_usuarios_form_lbnome');
end;

function TFViewUsuariosEdit.GetServidoresSelecionados: string;
var
  lElement: TJSHTMLInputElement;
  lIdCheckBox: string;
  lIndice : Integer;
begin
  Result := '';

  if cbxTodosServidores.Checked then
    Result := '99'
  else
  begin
    for lIndice := Low(FRecursosDisponiveis) to High(FRecursosDisponiveis) do
    begin
      lIdCheckBox := FPrefixoCheckBoxServidores + IntToStr(lIndice + 1);

      lElement := TJSHTMLInputElement(document.getElementById(lIdCheckBox));

      if Assigned(lElement) and lElement.checked then
        Result := Result + lElement.value + '|';
    end;

    Result := Copy(Result, 1, Length(Result) - 1);
  end;
end;

procedure TFViewUsuariosEdit.HiddenNotification;
begin
  //
end;

procedure TFViewUsuariosEdit.InsertEntity;
begin
  UsuariosDataset.Close;
  UsuariosDataset.SetJsonData('{}');
  UsuariosDataset.Open;
  UsuariosDataset.Insert;
end;

class function TFViewUsuariosEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewUsuariosEdit(AForm).FInserting := AInserting;
    TFViewUsuariosEdit(AForm).FId := AId;
    TFViewUsuariosEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewUsuariosEdit(AForm).InsertEntity
    else
      TFViewUsuariosEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewUsuariosEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewUsuariosEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    UsuariosDataset.Connection.Model.DefaultSchema.FindEntityType(
      UsuariosDataset.EntitySetName
    )
  );
  XDataClientUsuariosGet.Get(UsuariosDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewUsuariosEdit.SetDadosCds(pNovoRegistro: Boolean);
var
  lStatusAguardandoValidacao : Boolean;
begin
  lStatusAguardandoValidacao := pNovoRegistro;

  if not pNovoRegistro then
    pNovoRegistro := UsuariosDataset.FieldByName('perfil').AsInteger <> cbbPerfil.ItemIndex;

  UsuariosDataset.FieldByName('perfil').AsInteger := cbbPerfil.ItemIndex;
  UsuariosDataset.FieldByName('perfil_acesso').AsString := GetServidoresSelecionados;

  case cbbPerfil.ItemIndex of
    1:
    begin
      if pNovoRegistro then
      begin
        UsuariosDataset.FieldByName('aliado_id').Value := null;
        UsuariosDataset.FieldByName('parceiro_id').Value := null;
      end;
    end;
    2:
    begin
      if pNovoRegistro then
        UsuariosDataset.FieldByName('aliado_id').Value := null;

      UsuariosDataset.FieldByName('parceiro_id').AsInteger := edtParceiroNome.Tag;
    end;
    3:
    begin
      UsuariosDataset.FieldByName('aliado_id').AsInteger := edtAliadoNome.Tag;

      if pNovoRegistro then
        UsuariosDataset.FieldByName('parceiro_id').Value := null;
    end;
  end;

  if lStatusAguardandoValidacao then
    UsuariosDataset.FieldByName('status').AsInteger := 3
  else
    UsuariosDataset.FieldByName('status').AsInteger := cbbStatus.ItemIndex;

  UsuariosDataset.FieldByName('somente_apis').AsBoolean := cbxUtilizaSomenteApi.Checked;
end;

procedure TFViewUsuariosEdit.SetDadosTela;
var
  lToken : string;
begin
  cbbPerfil.ItemIndex := UsuariosDataset.FieldByName('perfil').AsInteger;
  cbbStatus.ItemIndex := UsuariosDataset.FieldByName('status').AsInteger;

  if cbbPerfil.ItemIndex = 2 then
  begin
    edtParceiroNome.Text := UsuariosDataset.FieldByName('parceiro.nome').AsString;

    edtParceiroNome.tag := UsuariosDataset.FieldByName('parceiro_id').AsInteger;
  end
  else if cbbPerfil.ItemIndex = 3 then
  begin
    edtAliadoNome.Text := UsuariosDataset.FieldByName('aliado.Nome_Fantasia').AsString;
    edtAliadoNome.tag := UsuariosDataset.FieldByName('aliado_id').AsInteger;
  end;

  ConfigurarPerfil;
  SetServidoresAliado;

  if cbbStatus.ItemIndex <> 3 then
    edemail.Enabled := False;

  if UsuariosDataset.FieldByName('somente_apis').AsBoolean then
  begin
    edemail.Enabled := False;
    cbbPerfil.Enabled := False;
    btnPesquisarAliado.Enabled := False;
    btnPesquisarParceiro.Enabled := False;
    TUtils.ControlarSelect('cbbStatus', 'Aguardando Validação', True);

    lToken := UsuariosDataset.FieldByName('token_longa_duracao').AsString;
    if not lToken.IsEmpty then
      edtExpiracaoToken.Text := FormatDateTime('dd/mm/yyyy hh:nn:ss', AuthService.TokenExpirationDate(lToken));

    if not TUtils.IsPerfilFacilSistemas(TUtils.FUsuario) then
    begin
      TUtils.RemoverElementoPorId('line-acesso_api-tab');
      TUtils.RemoverElementoPorId('line-acesso_api');
    end;
  end
  else
  begin
    TUtils.RemoverElementoPorId('line-acesso_api-tab');
    TUtils.RemoverElementoPorId('line-acesso_api');
  end;
end;

procedure TFViewUsuariosEdit.SetServidoresAliado;
var
  lServidoresAliado : TArray<string>;
  lIndice : Integer;
  lIdCheckBox : string;
  lElement: TJSHTMLInputElement;
begin
  cbxTodosServidores.Checked := UsuariosDataset.FieldByName('perfil_acesso').AsString = '99';

  if not cbxTodosServidores.Checked then
  begin
    lServidoresAliado := SplitString(UsuariosDataset.FieldByName('perfil_acesso').AsString, '|');

    for lIndice := Low(lServidoresAliado) to High(lServidoresAliado) do
    begin
      lIdCheckBox := FPrefixoCheckBoxServidores + lServidoresAliado[lIndice];
      lElement := TJSHTMLInputElement(document.getElementById(lIdCheckBox));

      if Assigned(lElement) then
        lElement.checked := True;
    end;
  end;

  ControlarCheckBoxServidores(not cbxTodosServidores.Checked);
end;

procedure TFViewUsuariosEdit.WebFormCreate(Sender: TObject);
begin
  CriarCheckBoxServidores;
  HiddenNotification;
end;

procedure TFViewUsuariosEdit.WebFormShow(Sender: TObject);
begin
  if FInserting then
  begin
    cbbStatus.ItemIndex := 3;
    cbbStatus.Enabled := False;

    if ednome.CanFocus then
      ednome.SetFocus;

    THelperServer.RemoverDiv('campos-controle');
    TUtils.RemoverElementoPorId(btnPermissoesUsuario.ElementID);
    TUtils.RemoverElementoPorId('line-acesso_api-tab');
    TUtils.RemoverElementoPorId('line-acesso_api');

    cbxUtilizaSomenteApi.Enabled := False;

    if TUtils.IsPerfilAliado(TUtils.FUsuario) then
    begin
      cbbPerfil.ItemIndex := 3;
      cbbPerfil.Enabled := False;
    end
    else if TUtils.IsPerfilParceiro(TUtils.FUsuario) then
    begin
      cbbPerfil.ItemIndex := 2;
      TUtils.ControlarSelect('cbbPerfil', 'Fácil Sistemas', True);
    end
    else
      cbxUtilizaSomenteApi.Enabled := True;

    ConfigurarPerfil;
  end
  else
  begin
    if TUtils.IsPerfilAliado(TUtils.FUsuario) then
      cbbPerfil.Enabled := False
    else if TUtils.IsPerfilParceiro(TUtils.FUsuario) then
      TUtils.ControlarSelect('cbbPerfil', 'Fácil Sistemas', True);

    cbxUtilizaSomenteApi.Enabled := False;
    btSave.Enabled := TUtils.PossuiPermissao(UsuariosDataset.EntitySetName.ToLower, TTipoPermissao.ALTERAR);
    btnAtualizarToken.Enabled := TUtils.PossuiPermissao(UsuariosDataset.EntitySetName.ToLower, TTipoPermissao.ALTERAR);
    btnPermissoesUsuario.Enabled := TUtils.PossuiPermissao('permissoes_usuario', TTipoPermissao.VISUALIZAR);
  end;
end;

procedure TFViewUsuariosEdit.XDataClientUsuariosGetLoad(Response: TXDataClientResponse);
begin
  UsuariosDataset.Close;
  UsuariosDataset.SetJsonData(Response.Result);
  UsuariosDataset.Open;

  UsuariosDataset.Edit;

  SetDadosTela;

  if not TUtils.PossuiPermissao(UsuariosDataset.EntitySetName.ToLower, TTipoPermissao.ALTERAR) then
  begin
    asm
      window.setTimeout(function() {
        pas.UUtils.TUtils.BloquearCamposDiv('camposFormUsuarios', true);
          }, 200);
    end;
  end;
end;

procedure TFViewUsuariosEdit.XDataWebClientTokenError(Error: TXDataClientError);
begin
  if FInserting then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Não foi possível gerar o token de acesso!' +
      sLineBreak + 'Acesse o cadastro do usuário e gere o mesmo.');

    FShowListProc;
  end
  else
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Não foi possível atualizar o token de acesso!' +
      sLineBreak + Error.ErrorMessage);
  end;
end;

procedure TFViewUsuariosEdit.XDataWebClientTokenLoad(
  Response: TXDataClientResponse);
var
  lToken : string;
begin
  if FInserting then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Usuário cadastrado com sucesso!');
    FShowListProc;
  end
  else
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Token atualizado com sucesso!');
    lToken := string(Response.ResultAsObject['value']);
    lToken := lToken.Replace('''', '');
    UsuariosDataset.FieldByName('token_longa_duracao').AsString := lToken;
    edtExpiracaoToken.Text := FormatDateTime('dd/mm/yyyy hh:nn:ss', AuthService.TokenExpirationDate(lToken));
  end;
end;

procedure TFViewUsuariosEdit.UsuariosDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
  lMensagem : string;
  lJson : TJSObject;
  lUsuarioId : Integer;
  lDataObject: TJSObject;
begin
  lMensagem := 'Usuário cadastrado com sucesso!';

  if not FInserting then
    lMensagem := 'Dados do usuário atualizados com sucesso!';

  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      if Pos('Duplicate entry', ResolveInfo.Error) > 0  then
      begin
        TUtils.OcultarDivLoading;
        TUtils.SetErroClass('view_usuarios_form_lbemail', 'Email já cadastrado no servidor!');
      end
      else
        TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, ResolveInfo.Error);

      UsuariosDataset.Edit;
      Exit;
    end;
  end;

  if cbxUtilizaSomenteApi.Checked and FInserting then
  begin
    lDataObject := TJSObject(ResolveInfo.Data);
    lUsuarioId := Integer(lDataObject.Properties['id']);
    lJson := TJSObject.New;
    lJson['primeiro_link'] := True;
    lJson['codigo_usuario'] := lUsuarioId;
    XDataWebClientToken.RawInvoke('IService.AtualizarTokenUsuario', [lJson]);
  end
  else
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, lMensagem);
    FShowListProc;
  end;
end;

function TFViewUsuariosEdit.ValidarPost: TArray<string>;
begin
  TUtils.LimparErrosClass;

  SetLength(Result, 2);
  Result[0] := '';
  Result[1] := 'view_usuarios_form_lbnome';

  if Trim(ednome.Text) = '' then
  begin
    Result[0] := 'Nome do usuário não pode ser vazio!';
    Result[1] := 'view_usuarios_form_lbnome';
  end
  else if not cbxUtilizaSomenteApi.Checked and (Trim(edemail.Text) = '') then
  begin
    Result[0] := 'Email do usuário não pode ser vazio!';
    Result[1] := 'view_usuarios_form_lbemail';
  end
  else if not cbxUtilizaSomenteApi.Checked and not TUtils.ValidarEmail(edemail.Text)  then
  begin
    Result[0] := 'Email inválido!';
    Result[1] := 'view_usuarios_form_lbemail';
  end
  else if (Trim(cbbStatus.Text) = '') and not FInserting then
  begin
    Result[0] := 'Selecione o status do usuário!';
    Result[1] := 'view_usuarios_form_lbstatus';
  end
  else if Trim(cbbPerfil.Text) = '' then
  begin
    Result[0] := 'Selecione o perfil do usuário!';
    Result[1] := 'view_usuarios_form_lbperfil';
  end
  else
  begin
    case cbbPerfil.ItemIndex of
      2:
      begin
        if Trim(edtParceiroNome.Text) = '' then
        begin
          Result[0] := 'Selecione um parceiro!';
          Result[1] := 'view_usuarios_form_lbparceiro';
        end;
      end;
      3:
      begin
        if Trim(edtAliadoNome.Text) = '' then
        begin
          Result[0] := 'Selecione um aliado!';
          Result[1] := 'view_usuarios_form_lbaliado';
        end
      end;
    end;
  end;
end;

procedure TFViewUsuariosEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewUsuariosEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.usuarios.form.lbid');
  lbperfil := TLabel.Create('view.usuarios.form.lbperfil');
  lbnome := TLabel.Create('view.usuarios.form.lbnome');
  lbemail := TLabel.Create('view.usuarios.form.lbemail');
  lbstatus := TLabel.Create('view.usuarios.form.lbstatus');
  lbultimo_acesso := TLabel.Create('view.usuarios.form.lbultimo_acesso');
  lbinclusao := TLabel.Create('view.usuarios.form.lbinclusao');
  lbalteracao := TLabel.Create('view.usuarios.form.lbalteracao');
  lblToken := TLabel.Create('lblToken');
  lblExpiracaoToken := TLabel.Create('lblExpiracaoToken');
  btCancel := TButton.Create('view.usuarios.form.btBack');
  btSave := TButton.Create('view.usuarios.form.btSave');
  edid := TDBEdit.Create('view.usuarios.form.edid');
  ednome := TDBEdit.Create('view.usuarios.form.ednome');
  edemail := TDBEdit.Create('view.usuarios.form.edemail');
  cbbStatus := TComboBox.Create('cbbStatus');
  cbbPerfil := TComboBox.Create('cbbPerfil');
  divAliado := THTMLDiv.Create('view_usuarios_form_lbaliado_error_div');
  lbaliado_id := TLabel.Create('view.usuarios.form.lbaliado_id');
  edtAliadoNome := TEdit.Create('edtAliadoNome');
  btnPesquisarAliado := TButton.Create('btnPesquisarAliado');
  divParceiro := THTMLDiv.Create('view_usuarios_form_lbparceiro_error_div');
  lbparceiro_id := TLabel.Create('view.usuarios.form.lbparceiro_id');
  edtParceiroNome := TEdit.Create('edtParceiroNome');
  btnPesquisarParceiro := TButton.Create('btnPesquisarParceiro');
  divCheckBoxServidores := THTMLDiv.Create('divCheckBoxServidores');
  cbxTodosServidores := TCheckBox.Create('cbxTodosServidores');
  btnPermissoesUsuario := TButton.Create('btnPermissoesUsuario');
  frmPermissoesUsuario := TFramePermissoesUsuario.Create(Self);
  pnlDados := TPanel.Create(Self);
  cbxUtilizaSomenteApi := TDBCheckBox.Create('cbxUtilizaSomenteApi');
  edultimo_acesso := TDBEdit.Create('view.usuarios.form.edultimo_acesso');
  edinclusao := TDBEdit.Create('view.usuarios.form.edinclusao');
  edalteracao := TDBEdit.Create('view.usuarios.form.edalteracao');
  pnlApi := TPanel.Create(Self);
  edtToken := TDBEdit.Create('edtToken');
  btnCopiarToken := TButton.Create('btnCopiarToken');
  edtExpiracaoToken := TEdit.Create('edtExpiracaoToken');
  btnAtualizarToken := TButton.Create('btnAtualizarToken');
  DataSource := TDataSource.Create(Self);
  UsuariosDataset := TXDataWebDataSet.Create(Self);
  UsuariosDatasetid := TIntegerField.Create(Self);
  UsuariosDatasetaliado_id := TIntegerField.Create(Self);
  UsuariosDatasetparceiro_id := TIntegerField.Create(Self);
  UsuariosDatasetperfil := TIntegerField.Create(Self);
  UsuariosDatasetnome := TStringField.Create(Self);
  UsuariosDatasetemail := TStringField.Create(Self);
  UsuariosDatasetstatus := TIntegerField.Create(Self);
  UsuariosDatasetultimo_acesso := TDateTimeField.Create(Self);
  UsuariosDatasetinclusao := TDateTimeField.Create(Self);
  UsuariosDatasetalteracao := TDateTimeField.Create(Self);
  UsuariosDatasetaliadoNome_Fantasia := TXDataWebDatasetField.Create(Self);
  UsuariosDatasetparceironome := TXDataWebEntityField.Create(Self);
  UsuariosDatasetperfil_acesso := TStringField.Create(Self);
  UsuariosDatasetsomente_apis := TBooleanField.Create(Self);
  UsuariosDatasettoken_longa_duracao := TStringField.Create(Self);
  XDataClientUsuariosGet := TXDataWebClient.Create(Self);
  XDataWebClientToken := TXDataWebClient.Create(Self);

  frmPermissoesUsuario.LoadFromForm;
  lbid.BeforeLoadDFMValues;
  lbperfil.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  lbemail.BeforeLoadDFMValues;
  lbstatus.BeforeLoadDFMValues;
  lbultimo_acesso.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lblToken.BeforeLoadDFMValues;
  lblExpiracaoToken.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  edemail.BeforeLoadDFMValues;
  cbbStatus.BeforeLoadDFMValues;
  cbbPerfil.BeforeLoadDFMValues;
  divAliado.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edtAliadoNome.BeforeLoadDFMValues;
  btnPesquisarAliado.BeforeLoadDFMValues;
  divParceiro.BeforeLoadDFMValues;
  lbparceiro_id.BeforeLoadDFMValues;
  edtParceiroNome.BeforeLoadDFMValues;
  btnPesquisarParceiro.BeforeLoadDFMValues;
  divCheckBoxServidores.BeforeLoadDFMValues;
  cbxTodosServidores.BeforeLoadDFMValues;
  btnPermissoesUsuario.BeforeLoadDFMValues;
  frmPermissoesUsuario.BeforeLoadDFMValues;
  frmPermissoesUsuario.lblDescricaoPermissao.BeforeLoadDFMValues;
  pnlDados.BeforeLoadDFMValues;
  cbxUtilizaSomenteApi.BeforeLoadDFMValues;
  edultimo_acesso.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  pnlApi.BeforeLoadDFMValues;
  edtToken.BeforeLoadDFMValues;
  btnCopiarToken.BeforeLoadDFMValues;
  edtExpiracaoToken.BeforeLoadDFMValues;
  btnAtualizarToken.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  UsuariosDataset.BeforeLoadDFMValues;
  UsuariosDatasetid.BeforeLoadDFMValues;
  UsuariosDatasetaliado_id.BeforeLoadDFMValues;
  UsuariosDatasetparceiro_id.BeforeLoadDFMValues;
  UsuariosDatasetperfil.BeforeLoadDFMValues;
  UsuariosDatasetnome.BeforeLoadDFMValues;
  UsuariosDatasetemail.BeforeLoadDFMValues;
  UsuariosDatasetstatus.BeforeLoadDFMValues;
  UsuariosDatasetultimo_acesso.BeforeLoadDFMValues;
  UsuariosDatasetinclusao.BeforeLoadDFMValues;
  UsuariosDatasetalteracao.BeforeLoadDFMValues;
  UsuariosDatasetaliadoNome_Fantasia.BeforeLoadDFMValues;
  UsuariosDatasetparceironome.BeforeLoadDFMValues;
  UsuariosDatasetperfil_acesso.BeforeLoadDFMValues;
  UsuariosDatasetsomente_apis.BeforeLoadDFMValues;
  UsuariosDatasettoken_longa_duracao.BeforeLoadDFMValues;
  XDataClientUsuariosGet.BeforeLoadDFMValues;
  XDataWebClientToken.BeforeLoadDFMValues;
  try
    Name := 'FViewUsuariosEdit';
    Width := 791;
    Height := 653;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 16;
    lbid.Top := 24;
    lbid.Width := 23;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbperfil.SetParentComponent(Self);
    lbperfil.Name := 'lbperfil';
    lbperfil.Left := 16;
    lbperfil.Top := 111;
    lbperfil.Width := 28;
    lbperfil.Height := 13;
    lbperfil.Caption := 'Perfil:';
    lbperfil.HeightPercent := 100.000000000000000000;
    lbperfil.WidthPercent := 100.000000000000000000;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 200;
    lbnome.Top := 24;
    lbnome.Width := 31;
    lbnome.Height := 13;
    lbnome.Caption := 'Nome:';
    lbnome.HeightPercent := 100.000000000000000000;
    lbnome.WidthPercent := 100.000000000000000000;
    lbemail.SetParentComponent(Self);
    lbemail.Name := 'lbemail';
    lbemail.Left := 200;
    lbemail.Top := 51;
    lbemail.Width := 28;
    lbemail.Height := 13;
    lbemail.Caption := 'Email:';
    lbemail.HeightPercent := 100.000000000000000000;
    lbemail.WidthPercent := 100.000000000000000000;
    lbstatus.SetParentComponent(Self);
    lbstatus.Name := 'lbstatus';
    lbstatus.Left := 200;
    lbstatus.Top := 78;
    lbstatus.Width := 35;
    lbstatus.Height := 13;
    lbstatus.Caption := 'Status:';
    lbstatus.HeightPercent := 100.000000000000000000;
    lbstatus.WidthPercent := 100.000000000000000000;
    lbultimo_acesso.SetParentComponent(Self);
    lbultimo_acesso.Name := 'lbultimo_acesso';
    lbultimo_acesso.Left := 200;
    lbultimo_acesso.Top := 104;
    lbultimo_acesso.Width := 70;
    lbultimo_acesso.Height := 13;
    lbultimo_acesso.Caption := #218'ltimo Acesso:';
    lbultimo_acesso.HeightPercent := 100.000000000000000000;
    lbultimo_acesso.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 200;
    lbinclusao.Top := 130;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 200;
    lbalteracao.Top := 155;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lblToken.SetParentComponent(Self);
    lblToken.Name := 'lblToken';
    lblToken.Left := 417;
    lblToken.Top := 34;
    lblToken.Width := 33;
    lblToken.Height := 13;
    lblToken.Caption := 'Token:';
    lblToken.HeightPercent := 100.000000000000000000;
    lblToken.WidthPercent := 100.000000000000000000;
    lblExpiracaoToken.SetParentComponent(Self);
    lblExpiracaoToken.Name := 'lblExpiracaoToken';
    lblExpiracaoToken.Left := 417;
    lblExpiracaoToken.Top := 61;
    lblExpiracaoToken.Width := 51;
    lblExpiracaoToken.Height := 13;
    lblExpiracaoToken.Caption := 'Expira'#231#227'o:';
    lblExpiracaoToken.HeightPercent := 100.000000000000000000;
    lblExpiracaoToken.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 118;
    btCancel.Top := 231;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 19;
    btSave.Top := 231;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.HeightPercent := 100.000000000000000000;
    btSave.TabOrder := 11;
    btSave.WidthPercent := 100.000000000000000000;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 69;
    edid.Top := 21;
    edid.Width := 125;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 269;
    ednome.Top := 21;
    ednome.Width := 102;
    ednome.Height := 21;
    ednome.HeightPercent := 100.000000000000000000;
    ednome.TabOrder := 1;
    ednome.Text := 'ednome';
    ednome.WidthPercent := 100.000000000000000000;
    SetEvent(ednome, Self, 'OnClick', 'ednomeClick');
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    edemail.SetParentComponent(Self);
    edemail.Name := 'edemail';
    edemail.Left := 269;
    edemail.Top := 48;
    edemail.Width := 102;
    edemail.Height := 21;
    edemail.HeightPercent := 100.000000000000000000;
    edemail.TabOrder := 2;
    edemail.Text := 'edemail';
    edemail.WidthPercent := 100.000000000000000000;
    SetEvent(edemail, Self, 'OnClick', 'edemailClick');
    edemail.DataField := 'email';
    edemail.DataSource := DataSource;
    cbbStatus.SetParentComponent(Self);
    cbbStatus.Name := 'cbbStatus';
    cbbStatus.Left := 269;
    cbbStatus.Top := 75;
    cbbStatus.Width := 102;
    cbbStatus.Height := 21;
    cbbStatus.HeightPercent := 100.000000000000000000;
    cbbStatus.TabOrder := 3;
    cbbStatus.WidthPercent := 100.000000000000000000;
    SetEvent(cbbStatus, Self, 'OnClick', 'cbbStatusClick');
    cbbStatus.ItemIndex := 0;
    cbbStatus.Items.BeginUpdate;
    try
      cbbStatus.Items.Clear;
      cbbStatus.Items.Add('');
      cbbStatus.Items.Add('Ativo');
      cbbStatus.Items.Add('Inativo/Bloqueado');
      cbbStatus.Items.Add('Aguardando Valida'#231#227'o');
    finally
      cbbStatus.Items.EndUpdate;
    end;
    cbbPerfil.SetParentComponent(Self);
    cbbPerfil.Name := 'cbbPerfil';
    cbbPerfil.Left := 69;
    cbbPerfil.Top := 108;
    cbbPerfil.Width := 125;
    cbbPerfil.Height := 21;
    cbbPerfil.HeightPercent := 100.000000000000000000;
    cbbPerfil.TabOrder := 4;
    cbbPerfil.WidthPercent := 100.000000000000000000;
    SetEvent(cbbPerfil, Self, 'OnChange', 'cbbPerfilChange');
    SetEvent(cbbPerfil, Self, 'OnClick', 'cbbPerfilClick');
    cbbPerfil.ItemIndex := 0;
    cbbPerfil.Items.BeginUpdate;
    try
      cbbPerfil.Items.Clear;
      cbbPerfil.Items.Add('');
      cbbPerfil.Items.Add('F'#225'cil Sistemas');
      cbbPerfil.Items.Add('Parceiro');
      cbbPerfil.Items.Add('Aliado');
    finally
      cbbPerfil.Items.EndUpdate;
    end;
    divAliado.SetParentComponent(Self);
    divAliado.Name := 'divAliado';
    divAliado.Left := 16;
    divAliado.Top := 44;
    divAliado.Width := 178;
    divAliado.Height := 33;
    divAliado.ChildOrder := 19;
    divAliado.Role := '';
    divAliado.Visible := False;
    lbaliado_id.SetParentComponent(divAliado);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 8;
    lbaliado_id.Top := 7;
    lbaliado_id.Width := 33;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'Aliado:';
    lbaliado_id.HeightPercent := 100.000000000000000000;
    lbaliado_id.WidthPercent := 100.000000000000000000;
    edtAliadoNome.SetParentComponent(divAliado);
    edtAliadoNome.Name := 'edtAliadoNome';
    edtAliadoNome.Left := 53;
    edtAliadoNome.Top := 3;
    edtAliadoNome.Width := 80;
    edtAliadoNome.Height := 22;
    edtAliadoNome.ChildOrder := 21;
    edtAliadoNome.Enabled := False;
    edtAliadoNome.HeightPercent := 100.000000000000000000;
    edtAliadoNome.WidthPercent := 100.000000000000000000;
    btnPesquisarAliado.SetParentComponent(divAliado);
    btnPesquisarAliado.Name := 'btnPesquisarAliado';
    btnPesquisarAliado.Left := 139;
    btnPesquisarAliado.Top := 4;
    btnPesquisarAliado.Width := 30;
    btnPesquisarAliado.Height := 21;
    btnPesquisarAliado.ChildOrder := 22;
    btnPesquisarAliado.HeightPercent := 100.000000000000000000;
    btnPesquisarAliado.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarAliado, Self, 'OnClick', 'btnPesquisarAliadoClick');
    divParceiro.SetParentComponent(Self);
    divParceiro.Name := 'divParceiro';
    divParceiro.Left := 16;
    divParceiro.Top := 79;
    divParceiro.Width := 178;
    divParceiro.Height := 26;
    divParceiro.ChildOrder := 17;
    divParceiro.Role := '';
    divParceiro.Visible := False;
    lbparceiro_id.SetParentComponent(divParceiro);
    lbparceiro_id.Name := 'lbparceiro_id';
    lbparceiro_id.Left := 8;
    lbparceiro_id.Top := 9;
    lbparceiro_id.Width := 43;
    lbparceiro_id.Height := 13;
    lbparceiro_id.Caption := 'Parceiro:';
    lbparceiro_id.HeightPercent := 100.000000000000000000;
    lbparceiro_id.WidthPercent := 100.000000000000000000;
    edtParceiroNome.SetParentComponent(divParceiro);
    edtParceiroNome.Name := 'edtParceiroNome';
    edtParceiroNome.Left := 61;
    edtParceiroNome.Top := 0;
    edtParceiroNome.Width := 72;
    edtParceiroNome.Height := 22;
    edtParceiroNome.ChildOrder := 21;
    edtParceiroNome.Enabled := False;
    edtParceiroNome.HeightPercent := 100.000000000000000000;
    edtParceiroNome.WidthPercent := 100.000000000000000000;
    btnPesquisarParceiro.SetParentComponent(divParceiro);
    btnPesquisarParceiro.Name := 'btnPesquisarParceiro';
    btnPesquisarParceiro.Left := 139;
    btnPesquisarParceiro.Top := 1;
    btnPesquisarParceiro.Width := 30;
    btnPesquisarParceiro.Height := 21;
    btnPesquisarParceiro.ChildOrder := 22;
    btnPesquisarParceiro.HeightPercent := 100.000000000000000000;
    btnPesquisarParceiro.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarParceiro, Self, 'OnClick', 'btnPesquisarParceiroClick');
    divCheckBoxServidores.SetParentComponent(Self);
    divCheckBoxServidores.Name := 'divCheckBoxServidores';
    divCheckBoxServidores.Left := 16;
    divCheckBoxServidores.Top := 131;
    divCheckBoxServidores.Width := 178;
    divCheckBoxServidores.Height := 41;
    divCheckBoxServidores.ChildOrder := 7;
    divCheckBoxServidores.Role := '';
    cbxTodosServidores.SetParentComponent(Self);
    cbxTodosServidores.Name := 'cbxTodosServidores';
    cbxTodosServidores.Left := 16;
    cbxTodosServidores.Top := 177;
    cbxTodosServidores.Width := 178;
    cbxTodosServidores.Height := 22;
    cbxTodosServidores.Caption := 'cbxTodosServidores';
    cbxTodosServidores.ChildOrder := 16;
    cbxTodosServidores.HeightPercent := 100.000000000000000000;
    cbxTodosServidores.TabOrder := 7;
    cbxTodosServidores.WidthPercent := 100.000000000000000000;
    SetEvent(cbxTodosServidores, Self, 'OnClick', 'cbxTodosServidoresClick');
    btnPermissoesUsuario.SetParentComponent(Self);
    btnPermissoesUsuario.Name := 'btnPermissoesUsuario';
    btnPermissoesUsuario.Left := 218;
    btnPermissoesUsuario.Top := 231;
    btnPermissoesUsuario.Width := 96;
    btnPermissoesUsuario.Height := 25;
    btnPermissoesUsuario.Caption := 'Permiss'#245'es';
    btnPermissoesUsuario.ChildOrder := 17;
    btnPermissoesUsuario.HeightPercent := 100.000000000000000000;
    btnPermissoesUsuario.WidthPercent := 100.000000000000000000;
    SetEvent(btnPermissoesUsuario, Self, 'OnClick', 'btnPermissoesUsuarioClick');
    frmPermissoesUsuario.SetParentComponent(Self);
    frmPermissoesUsuario.Name := 'frmPermissoesUsuario';
    frmPermissoesUsuario.Left := 16;
    frmPermissoesUsuario.Top := 260;
    frmPermissoesUsuario.Width := 768;
    frmPermissoesUsuario.Height := 388;
    frmPermissoesUsuario.TabOrder := 12;
    frmPermissoesUsuario.Visible := False;
    frmPermissoesUsuario.lblDescricaoPermissao.Width := 48;
    frmPermissoesUsuario.lblDescricaoPermissao.Height := 13;
    pnlDados.SetParentComponent(Self);
    pnlDados.Name := 'pnlDados';
    pnlDados.Left := 16;
    pnlDados.Top := 1;
    pnlDados.Width := 355;
    pnlDados.Height := 17;
    pnlDados.Caption := 'Espa'#231'o Form Usu'#225'rio';
    pnlDados.ChildOrder := 23;
    pnlDados.Color := clInfoText;
    pnlDados.Font.Charset := DEFAULT_CHARSET;
    pnlDados.Font.Color := clWhite;
    pnlDados.Font.Height := -11;
    pnlDados.Font.Name := 'Tahoma';
    pnlDados.Font.Style := [fsBold];
    pnlDados.ParentFont := False;
    pnlDados.TabOrder := 13;
    pnlDados.Visible := False;
    cbxUtilizaSomenteApi.SetParentComponent(Self);
    cbxUtilizaSomenteApi.Name := 'cbxUtilizaSomenteApi';
    cbxUtilizaSomenteApi.Left := 19;
    cbxUtilizaSomenteApi.Top := 207;
    cbxUtilizaSomenteApi.Width := 175;
    cbxUtilizaSomenteApi.Height := 18;
    cbxUtilizaSomenteApi.Caption := 'cbxUtilizaSomenteApi';
    cbxUtilizaSomenteApi.ChildOrder := 20;
    cbxUtilizaSomenteApi.HeightPercent := 100.000000000000000000;
    cbxUtilizaSomenteApi.WidthPercent := 100.000000000000000000;
    SetEvent(cbxUtilizaSomenteApi, Self, 'OnClick', 'cbxUtilizaSomenteApiClick');
    cbxUtilizaSomenteApi.DataField := 'somente_apis';
    cbxUtilizaSomenteApi.DataSource := DataSource;
    edultimo_acesso.SetParentComponent(Self);
    edultimo_acesso.Name := 'edultimo_acesso';
    edultimo_acesso.Left := 271;
    edultimo_acesso.Top := 101;
    edultimo_acesso.Width := 100;
    edultimo_acesso.Height := 21;
    edultimo_acesso.ChildOrder := 3;
    edultimo_acesso.Enabled := False;
    edultimo_acesso.HeightPercent := 100.000000000000000000;
    edultimo_acesso.TabOrder := 14;
    edultimo_acesso.Text := 'edultimo_acesso';
    edultimo_acesso.WidthPercent := 100.000000000000000000;
    edultimo_acesso.DataField := 'ultimo_acesso';
    edultimo_acesso.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 271;
    edinclusao.Top := 127;
    edinclusao.Width := 100;
    edinclusao.Height := 21;
    edinclusao.ChildOrder := 4;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 15;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 270;
    edalteracao.Top := 152;
    edalteracao.Width := 100;
    edalteracao.Height := 21;
    edalteracao.ChildOrder := 5;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 16;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    pnlApi.SetParentComponent(Self);
    pnlApi.Name := 'pnlApi';
    pnlApi.Left := 417;
    pnlApi.Top := 8;
    pnlApi.Width := 355;
    pnlApi.Height := 17;
    pnlApi.Caption := 'Espa'#231'o Acesso Api';
    pnlApi.ChildOrder := 23;
    pnlApi.Color := clInfoText;
    pnlApi.Font.Charset := DEFAULT_CHARSET;
    pnlApi.Font.Color := clWhite;
    pnlApi.Font.Height := -11;
    pnlApi.Font.Name := 'Tahoma';
    pnlApi.Font.Style := [fsBold];
    pnlApi.ParentFont := False;
    pnlApi.TabOrder := 18;
    pnlApi.Visible := False;
    edtToken.SetParentComponent(Self);
    edtToken.Name := 'edtToken';
    edtToken.Left := 485;
    edtToken.Top := 31;
    edtToken.Width := 102;
    edtToken.Height := 21;
    edtToken.ChildOrder := 28;
    edtToken.Enabled := False;
    edtToken.HeightPercent := 100.000000000000000000;
    edtToken.TabOrder := 1;
    edtToken.Text := 'edtToken';
    edtToken.WidthPercent := 100.000000000000000000;
    edtToken.DataField := 'token_longa_duracao';
    edtToken.DataSource := DataSource;
    btnCopiarToken.SetParentComponent(Self);
    btnCopiarToken.Name := 'btnCopiarToken';
    btnCopiarToken.Left := 587;
    btnCopiarToken.Top := 31;
    btnCopiarToken.Width := 30;
    btnCopiarToken.Height := 21;
    btnCopiarToken.ChildOrder := 22;
    btnCopiarToken.HeightPercent := 100.000000000000000000;
    btnCopiarToken.WidthPercent := 100.000000000000000000;
    SetEvent(btnCopiarToken, Self, 'OnClick', 'btnCopiarTokenClick');
    edtExpiracaoToken.SetParentComponent(Self);
    edtExpiracaoToken.Name := 'edtExpiracaoToken';
    edtExpiracaoToken.Left := 485;
    edtExpiracaoToken.Top := 58;
    edtExpiracaoToken.Width := 132;
    edtExpiracaoToken.Height := 22;
    edtExpiracaoToken.ChildOrder := 21;
    edtExpiracaoToken.Enabled := False;
    edtExpiracaoToken.HeightPercent := 100.000000000000000000;
    edtExpiracaoToken.WidthPercent := 100.000000000000000000;
    btnAtualizarToken.SetParentComponent(Self);
    btnAtualizarToken.Name := 'btnAtualizarToken';
    btnAtualizarToken.Left := 417;
    btnAtualizarToken.Top := 86;
    btnAtualizarToken.Width := 96;
    btnAtualizarToken.Height := 25;
    btnAtualizarToken.Caption := 'Atualizar';
    btnAtualizarToken.ChildOrder := 32;
    btnAtualizarToken.HeightPercent := 100.000000000000000000;
    btnAtualizarToken.TabOrder := 11;
    btnAtualizarToken.WidthPercent := 100.000000000000000000;
    SetEvent(btnAtualizarToken, Self, 'OnClick', 'btnAtualizarTokenClick');
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := UsuariosDataset;
    DataSource.Left := 312;
    DataSource.Top := 184;
    UsuariosDataset.SetParentComponent(Self);
    UsuariosDataset.Name := 'UsuariosDataset';
    UsuariosDataset.AfterApplyUpdates := UsuariosDatasetAfterApplyUpdates;
    UsuariosDataset.EntitySetName := 'Usuarios';
    UsuariosDataset.Connection := DMConnection.ApiConnection;
    UsuariosDataset.Left := 216;
    UsuariosDataset.Top := 184;
    UsuariosDatasetid.SetParentComponent(UsuariosDataset);
    UsuariosDatasetid.Name := 'UsuariosDatasetid';
    UsuariosDatasetid.FieldName := 'id';
    UsuariosDatasetaliado_id.SetParentComponent(UsuariosDataset);
    UsuariosDatasetaliado_id.Name := 'UsuariosDatasetaliado_id';
    UsuariosDatasetaliado_id.FieldName := 'aliado_id';
    UsuariosDatasetparceiro_id.SetParentComponent(UsuariosDataset);
    UsuariosDatasetparceiro_id.Name := 'UsuariosDatasetparceiro_id';
    UsuariosDatasetparceiro_id.FieldName := 'parceiro_id';
    UsuariosDatasetperfil.SetParentComponent(UsuariosDataset);
    UsuariosDatasetperfil.Name := 'UsuariosDatasetperfil';
    UsuariosDatasetperfil.FieldName := 'perfil';
    UsuariosDatasetnome.SetParentComponent(UsuariosDataset);
    UsuariosDatasetnome.Name := 'UsuariosDatasetnome';
    UsuariosDatasetnome.FieldName := 'nome';
    UsuariosDatasetnome.Size := 255;
    UsuariosDatasetemail.SetParentComponent(UsuariosDataset);
    UsuariosDatasetemail.Name := 'UsuariosDatasetemail';
    UsuariosDatasetemail.FieldName := 'email';
    UsuariosDatasetemail.Size := 255;
    UsuariosDatasetstatus.SetParentComponent(UsuariosDataset);
    UsuariosDatasetstatus.Name := 'UsuariosDatasetstatus';
    UsuariosDatasetstatus.FieldName := 'status';
    UsuariosDatasetultimo_acesso.SetParentComponent(UsuariosDataset);
    UsuariosDatasetultimo_acesso.Name := 'UsuariosDatasetultimo_acesso';
    UsuariosDatasetultimo_acesso.FieldName := 'ultimo_acesso';
    UsuariosDatasetultimo_acesso.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    UsuariosDatasetinclusao.SetParentComponent(UsuariosDataset);
    UsuariosDatasetinclusao.Name := 'UsuariosDatasetinclusao';
    UsuariosDatasetinclusao.FieldName := 'inclusao';
    UsuariosDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    UsuariosDatasetalteracao.SetParentComponent(UsuariosDataset);
    UsuariosDatasetalteracao.Name := 'UsuariosDatasetalteracao';
    UsuariosDatasetalteracao.FieldName := 'alteracao';
    UsuariosDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    UsuariosDatasetaliadoNome_Fantasia.SetParentComponent(UsuariosDataset);
    UsuariosDatasetaliadoNome_Fantasia.Name := 'UsuariosDatasetaliadoNome_Fantasia';
    UsuariosDatasetaliadoNome_Fantasia.FieldKind := fkCalculated;
    UsuariosDatasetaliadoNome_Fantasia.FieldName := 'aliado.Nome_Fantasia';
    UsuariosDatasetaliadoNome_Fantasia.Calculated := True;
    UsuariosDatasetparceironome.SetParentComponent(UsuariosDataset);
    UsuariosDatasetparceironome.Name := 'UsuariosDatasetparceironome';
    UsuariosDatasetparceironome.FieldKind := fkCalculated;
    UsuariosDatasetparceironome.FieldName := 'parceiro.nome';
    UsuariosDatasetparceironome.Calculated := True;
    UsuariosDatasetperfil_acesso.SetParentComponent(UsuariosDataset);
    UsuariosDatasetperfil_acesso.Name := 'UsuariosDatasetperfil_acesso';
    UsuariosDatasetperfil_acesso.FieldName := 'perfil_acesso';
    UsuariosDatasetperfil_acesso.Size := 255;
    UsuariosDatasetsomente_apis.SetParentComponent(UsuariosDataset);
    UsuariosDatasetsomente_apis.Name := 'UsuariosDatasetsomente_apis';
    UsuariosDatasetsomente_apis.FieldName := 'somente_apis';
    UsuariosDatasetsomente_apis.Required := True;
    UsuariosDatasettoken_longa_duracao.SetParentComponent(UsuariosDataset);
    UsuariosDatasettoken_longa_duracao.Name := 'UsuariosDatasettoken_longa_duracao';
    UsuariosDatasettoken_longa_duracao.FieldName := 'token_longa_duracao';
    UsuariosDatasettoken_longa_duracao.Size := 255;
    XDataClientUsuariosGet.SetParentComponent(Self);
    XDataClientUsuariosGet.Name := 'XDataClientUsuariosGet';
    XDataClientUsuariosGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientUsuariosGet, Self, 'OnLoad', 'XDataClientUsuariosGetLoad');
    XDataClientUsuariosGet.Left := 264;
    XDataClientUsuariosGet.Top := 184;
    XDataWebClientToken.SetParentComponent(Self);
    XDataWebClientToken.Name := 'XDataWebClientToken';
    XDataWebClientToken.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebClientToken, Self, 'OnLoad', 'XDataWebClientTokenLoad');
    SetEvent(XDataWebClientToken, Self, 'OnError', 'XDataWebClientTokenError');
    XDataWebClientToken.Left := 456;
    XDataWebClientToken.Top := 152;
  finally
    lbid.AfterLoadDFMValues;
    lbperfil.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    lbemail.AfterLoadDFMValues;
    lbstatus.AfterLoadDFMValues;
    lbultimo_acesso.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lblToken.AfterLoadDFMValues;
    lblExpiracaoToken.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    edemail.AfterLoadDFMValues;
    cbbStatus.AfterLoadDFMValues;
    cbbPerfil.AfterLoadDFMValues;
    divAliado.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edtAliadoNome.AfterLoadDFMValues;
    btnPesquisarAliado.AfterLoadDFMValues;
    divParceiro.AfterLoadDFMValues;
    lbparceiro_id.AfterLoadDFMValues;
    edtParceiroNome.AfterLoadDFMValues;
    btnPesquisarParceiro.AfterLoadDFMValues;
    divCheckBoxServidores.AfterLoadDFMValues;
    cbxTodosServidores.AfterLoadDFMValues;
    btnPermissoesUsuario.AfterLoadDFMValues;
    frmPermissoesUsuario.AfterLoadDFMValues;
    frmPermissoesUsuario.lblDescricaoPermissao.AfterLoadDFMValues;
    pnlDados.AfterLoadDFMValues;
    cbxUtilizaSomenteApi.AfterLoadDFMValues;
    edultimo_acesso.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    pnlApi.AfterLoadDFMValues;
    edtToken.AfterLoadDFMValues;
    btnCopiarToken.AfterLoadDFMValues;
    edtExpiracaoToken.AfterLoadDFMValues;
    btnAtualizarToken.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    UsuariosDataset.AfterLoadDFMValues;
    UsuariosDatasetid.AfterLoadDFMValues;
    UsuariosDatasetaliado_id.AfterLoadDFMValues;
    UsuariosDatasetparceiro_id.AfterLoadDFMValues;
    UsuariosDatasetperfil.AfterLoadDFMValues;
    UsuariosDatasetnome.AfterLoadDFMValues;
    UsuariosDatasetemail.AfterLoadDFMValues;
    UsuariosDatasetstatus.AfterLoadDFMValues;
    UsuariosDatasetultimo_acesso.AfterLoadDFMValues;
    UsuariosDatasetinclusao.AfterLoadDFMValues;
    UsuariosDatasetalteracao.AfterLoadDFMValues;
    UsuariosDatasetaliadoNome_Fantasia.AfterLoadDFMValues;
    UsuariosDatasetparceironome.AfterLoadDFMValues;
    UsuariosDatasetperfil_acesso.AfterLoadDFMValues;
    UsuariosDatasetsomente_apis.AfterLoadDFMValues;
    UsuariosDatasettoken_longa_duracao.AfterLoadDFMValues;
    XDataClientUsuariosGet.AfterLoadDFMValues;
    XDataWebClientToken.AfterLoadDFMValues;
  end;
end;

end.
